<script setup>
import { computed } from 'vue';
import { useLoadingStore } from '../../stores/loading-store';

const loadingStore = useLoadingStore();

const isLoading = computed(() => loadingStore.loading);
</script>

<template>
  <div
    id="page-progress-bar"
    :class="{ loading: isLoading, done: !isLoading && loadingStore.done }"
  />
</template>
